import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useWindowSize } from "react-use";

const NavPillTrack = () => {
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <form
      onSubmit={handleSubmit(values => {
        navigate(`/tracking?id=${values.orderId}`);
      })}
    >
      <div className="d-flex flex-wrap mt-2">
        <Form.Control
          style={{ fontSize: width > 767 ? 16 : 14 }}
          className="w-100 w-md-75 border border-2 rounded-0"
          size="lg"
          type="text"
          placeholder="شماره سفارش یا بارکد خود را وارد کنید"
          defaultValue={params.get("id")}
          {...register("orderId", {
            required: { value: true, message: "شماره سفارش یا بارکد الزامی" },
          })}
        />
        <button
          type="submit"
          className="w-100 w-md-25 btn-success-style rounded-0"
        >
          جستجو
        </button>
      </div>
      {errors.orderId && (
        <p className="fs-samll text-danger">{errors.orderId.message}</p>
      )}
    </form>
  );
};
export default NavPillTrack;
